<template>
	<div class="emission-container">
		<div class="emission-cards-grid">
			<div
				v-for="card in emissionCards"
				:key="card.key"
				class="emission-col"
			>
				<div :class="['emission-card', card.themeClass]">
					<i :class="card.icon" class="emission-icon"></i>
					<h3>{{ card.title }}</h3>
					<template v-if="card.key === 'shipping'">
						<p class="shipping-line">Ingoing: <count-up :end-val="normalizedIngoingShipping" class="number"></count-up> kgs</p>
						<p class="shipping-line shipping-line-outgoing">Outgoing: <count-up :end-val="normalizedOutgoingShipping" class="number"></count-up> kgs</p>
					</template>
					<template v-else>
						<count-up :end-val="card.value" class="number"></count-up>
						<p class="label">kgs of CO₂</p>
					</template>
				</div>
			</div>
		</div>

		<div class="emission-total-wrap">
			<div class="emission-card total">
				<i class="fas fa-globe-americas emission-icon"></i>
				<h3>Total CO2 Emission</h3>
				<count-up :end-val="normalizedTotalEmission" class="total-number"></count-up>
				<p class="label">kgs of CO₂</p>
			</div>
		</div>
	</div>
</template>

<script>
import CountUp from "vue-countup-v2"

export default {
	name: "SupplierEmissions",
	components: { CountUp },
	props: {
		title: String,
		emissionEnergy: {
			type: Number,
			default: 0,
		},
		emissionBusinessTrips: {
			type: Number,
			default: 0,
		},
		emissionIngoingShipping: {
			type: Number,
			default: 0,
		},
		emissionOutgoingShipping: {
			type: Number,
			default: 0,
		},
		emissionCompanyOrganization: {
			type: Number,
			default: 0,
		},
		emissionPackaging: {
			type: Number,
			default: 0,
		},
		totalEmission: {
			type: Number,
			default: 0,
		},
	},
	computed: {
		normalizedEnergy() {
			return Number(this.emissionEnergy) || 0
		},
		normalizedBusinessTrips() {
			return Number(this.emissionBusinessTrips) || 0
		},
		normalizedIngoingShipping() {
			return Number(this.emissionIngoingShipping) || 0
		},
		normalizedOutgoingShipping() {
			return Number(this.emissionOutgoingShipping) || 0
		},
		normalizedCompanyOrganization() {
			return Number(this.emissionCompanyOrganization) || 0
		},
		normalizedPackaging() {
			return Number(this.emissionPackaging) || 0
		},
		normalizedTotalEmission() {
			return Number(this.totalEmission) || 0
		},
		emissionCards() {
			return [
				{
					key: "energy",
					title: "Energy Consumption",
					icon: "fas fa-bolt",
					themeClass: "energy",
					value: this.normalizedEnergy,
				},
				{
					key: "business",
					title: "Business Trips",
					icon: "fas fa-plane",
					themeClass: "business",
					value: this.normalizedBusinessTrips,
				},
				{
					key: "shipping",
					title: "Shipping",
					icon: "fas fa-shipping-fast",
					themeClass: "shipping",
					value: 0,
				},
				{
					key: "facility",
					title: "Facility Organization",
					icon: "fas fa-building",
					themeClass: "office",
					value: this.normalizedCompanyOrganization,
				},
				{
					key: "packaging",
					title: "Packaging",
					icon: "fas fa-box",
					themeClass: "emission-packaging",
					value: this.normalizedPackaging,
				},
			]
		},
	},
	data() {
		return {


		}
	},
	mounted() {

	},
	methods: {

	},
}
</script>

<style scoped>
/* Reuse the "emission-card" styling for a cohesive look, 
   then customize the total card a bit differently. */

.emission-container {
  font-family: Arial, sans-serif;
  padding: 12px 16px;
  max-width: 980px;
  margin: 0 auto;
}

.emission-cards-grid {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 10px;
}

.emission-col {
  flex: 0 0 168px;
  max-width: 168px;
  display: flex;
}

.emission-total-wrap {
  display: flex;
  justify-content: center;
  margin-top: 20px;
}

.emission-total-wrap .emission-card {
  width: 100%;
  max-width: 300px;
}

@media (max-width: 599px) {
  .emission-col {
    flex: 0 0 calc(50% - 10px);
    max-width: calc(50% - 10px);
  }

  .emission-col:nth-child(5) {
    flex: 0 0 100%;
    max-width: 280px;
    margin: 0 auto;
  }
}

.shipping-line {
  margin-top: 6px;
  white-space: nowrap;
  font-size: 12px;
}

.shipping-line-outgoing {
  margin-top: 8px;
}

.label {
	font-size: 12px;
	color: white;
	margin-top: 4px;
	line-height: 1.3;
}
/* Base emission card styling */
.emission-card {
  width: 100%;
  min-height: 150px;
  padding: 14px 10px;
  border-radius: 8px;
  color: white;
  text-align: center;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease-in-out;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.emission-card:hover {
  transform: scale(1.03);
}

/* Specific gradients for each category */
.energy {
  background: linear-gradient(to right, #f9a825, #f57c00);
}
.business {
  background: linear-gradient(to right, #d32f2f, #b71c1c);
}
.shipping {
  background: linear-gradient(to right, #388e3c, #2e7d32);
}
.office {
  background: linear-gradient(to right, #5c6bc0, #3949ab);
}
.emission-packaging {
  background: linear-gradient(to right, #8e24aa, #6a1b9a);
}

/* New style for the total card */
.total {
  background: linear-gradient(to right, #00838f, #006064);
  /* or pick any color scheme you like */
}

/* Icon styling */

i {
  font-size: 30px;
  margin-bottom: 10px;
}

h3 {
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 10px;
}

p {
  font-size: 14px;
  margin-top: 5px;
}

.number {
  font-size: 28px;
  font-weight: bold;
}

.total-number {
  font-size: 36px;
  font-weight: bold;
  color: #ffffff;
}
/* Keep the total-row separation if you like */
.total-row {
  margin-top: 30px;
  justify-content: center;
}
</style>

